import {Component} from "./Component";

function setCookie(name,value,days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i=0;i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}


/**
 *
 * @param {string} name Name of the cookie to delete
 * @param {string|undefined} path Optional path
 * @param {string|undefined} domain Optional domain
 */
function deleteCookie(name, path, domain) {
    if (!getCookie(name)) return;
    document.cookie = name + "=" +
        ((path) ? ";path="+path:"")+
        ((domain)?";domain="+domain:"") +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
}

export class CookieBanner extends Component {
    static name = "cookie-banner";

    get name() {
        return CookieBanner.name;
    }

    constructor(el) {
        super(el);

        this.$btnAccept = this.$("btnAccept");

        this.$form = this.querySelector("form");

        this.addEventListener(this.$form, "submit", this.onSubmit.bind(this));
        this.addEventListener(this.$btnAccept, "click", this.onClickAccept.bind(this));

        // Show overlay if cookies has not been accepted
        if (!getCookie("_dw_cp_accepted")) {
            setTimeout(() => {
                this.show();
            }, 2000);
        }

    }

    /**
     *
     * @param {SubmitEvent} e
     */
    onSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        const data = new FormData(e.target);

        const level = data.get("optional_cookies") === "on" ? 2 : 1;

        this._accept(level);

    }

    onClickAccept() {
        this._accept(2);
    }

    hide() {
        this.el.classList.remove("cookie-banner--visible");
    }

    show() {
        this.el.classList.add("cookie-banner--visible");
    }


    /**
     * Accept cookies with level
     * @param {number|string} level - 1 for essential cookies, 2 for essential and optional cookies
     * @private
     */
    _accept(level) {
        setCookie("_dw_cp_accepted", "1", Infinity);
        setCookie("_dw_cp_level", String(level), Infinity);
        window.location.reload();
    }

    /**
     * Returns cookie policy level or null if not set yet
     * @return {number|null}
     */
    getAcceptedLevel() {
        const val = getCookie("_dw_cp_level");

        return val?.length ? parseInt(val, 10) : null;
    }

    /**
     * Reset cookie banner state by deleting cookies
     */
    reset() {
        deleteCookie("_dw_cp_accepted");
        deleteCookie("_dw_cp_level");
    }

}
